import { ROOT_API, Roles } from 'constants/common';

export const formatImageUrl = url => {
  if (url.includes('https') || url.includes('http')) {
    return url;
  }
  return ROOT_API.concat('/', url);
};

export const checkAccessScreen = ({ userRoles, groupName, groupPermission }) => {
  if (userRoles.includes(Roles.ADMIN) || !groupName) return true;

  const groupIndex = groupPermission?.findIndex(item => groupName.includes(item));

  return groupIndex > -1 ? true : false;
};
